/* eslint-disable @github-ui/github-monorepo/filename-convention */
// List of announcement IDs that use WebGL animations
export const WEBGL_SCENE_IDS: string[] = []

// List of announcement IDs that use DOM animations
export const DOM_ANIMATION_IDS: string[] = []
